import { z } from 'zod';

export const QuestionDataSchema = z.object({
    category: z.string().min(1, 'Category is required'),
    topic: z.string().min(1, 'Topic is required'),
    value: z.string().min(1, 'Question is required'),
});
export type QuestionData = z.infer<typeof QuestionDataSchema>;

/** A question as the question bank editor shows it. */
export const QuestionRowSchema = z.object({
    id: z.coerce.number(),
}).extend(QuestionDataSchema.shape);
export type QuestionRow = z.infer<typeof QuestionRowSchema>;

/**
 * Where a question comes from, relative to the scope being viewed:
 * - `application`: an application default (shown to every brand unless the brand hides it)
 * - `brand`: added by the brand being viewed
 */
export const QuestionSourceSchema = z.enum(['application', 'brand']);
export type QuestionSource = z.infer<typeof QuestionSourceSchema>;

/** A question in the editor's list, with where it comes from and whether the viewed brand hides it. */
export const ScopedQuestionRowSchema = QuestionRowSchema.extend({
    source: QuestionSourceSchema,
    hidden: z.boolean(),
});
export type ScopedQuestionRow = z.infer<typeof ScopedQuestionRowSchema>;
